export default "__VITE_ASSET__2d353201__"